import React, { useEffect } from 'react'
import recommendation1 from '../assets/recommendation1.png';
import recommendation2 from '../assets/recommendation2.png';
import recommendation3 from '../assets/recommendation3.png';
import recommendation4 from '../assets/recommendation4.png';
import { useProperty } from '../context/PropertyContext.js';
import { Link } from 'react-router-dom';


const serverUrlImage = 'https://osdevhub.com/projects/homify/uploads';


function formatWithComma(price) {
    return parseInt(price).toLocaleString('en-US');
}



const HighProperties = () => {
    const {topRatedPropertiesData, fetchTopRatedProperties} = useProperty();

    useEffect(() => {
        fetchTopRatedProperties()
    }, [])



    

  return (
        <div className='personal-properties-container margin-top'>
            <section class="property-container margin-top2">
                <h2>Top 20 Rated Properties</h2>
                <ul class="property-list" id="top-listings">
                    {
                        topRatedPropertiesData?.map(top => (
                            
                            <Link to={`/dashboard/homeproperties/${top.id}?user_id=${top.user_id}`}>
                                <li key={top?.id}>
                                    <img className="property-image" src={`${serverUrlImage}/${top?.image}`} alt={top?.name} />
                                    <div class="property-details">
                                        <h3>{top?.name}</h3>
                                        <p><strong>Location: </strong>{top?.address}</p>
                                        <p><strong>Type:</strong> {top?.type_of_property}</p>
                                        <p><strong>Price:</strong> {formatWithComma(top?.price)}</p>
                                        <p> <strong>Description:</strong>{top?.description}</p>
                                    </div>
                                </li>
                            </Link>
                
                        ))
                    }
                    
                </ul>
            </section>
        </div>
  )
}

export default HighProperties